// Class: openfl.display._internal.ScriptLoader

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $hxEnums = require("./../../../hxEnums_stub").default;
var $import = require("./../../../import_stub").default;
function openfl_display_IDisplayObjectLoader() {return require("./../../../openfl/display/IDisplayObjectLoader");}
function lime_app_Promise() {return require("./../../../lime/app/Promise");}
function openfl_net_URLLoader() {return require("./../../../openfl/net/URLLoader");}
function Std() {return require("./../../../Std");}
function openfl_display_Sprite() {return require("./../../../openfl/display/Sprite");}

// Constructor

var ScriptLoader = function() {
}

// Meta

ScriptLoader.__name__ = "openfl.display._internal.ScriptLoader";
ScriptLoader.__isInterface__ = false;
ScriptLoader.__interfaces__ = [(openfl_display_IDisplayObjectLoader().default)];
ScriptLoader.prototype = {
	load: function(request,context,contentLoaderInfo) {
		if(contentLoaderInfo.contentType != null && (contentLoaderInfo.contentType.indexOf("/javascript") > -1 || contentLoaderInfo.contentType.indexOf("/ecmascript") > -1)) {
			var promise = new (lime_app_Promise().default)();
			var loader = new (openfl_net_URLLoader().default)();
			loader.dataFormat = "text";
			loader.addEventListener("complete",function(event) {
				(eval)("(function () {" + (Std().default).string(loader.data) + "})()");
				promise.complete(new (openfl_display_Sprite().default)());
			});
			loader.addEventListener("ioError",function(event1) {
				promise.error(event1);
			});
			loader.addEventListener("progress",function(event2) {
				var tmp = (Std().default).int(event2.bytesLoaded);
				var tmp1 = (Std().default).int(event2.bytesTotal);
				promise.progress(tmp,tmp1);
			});
			loader.load(request);
			return promise.future;
		} else {
			return null;
		}
	},
	loadBytes: function(buffer,context,contentLoaderInfo) {
		return null;
	}
};
ScriptLoader.prototype.__class__ = ScriptLoader.prototype.constructor = $hxClasses["openfl.display._internal.ScriptLoader"] = ScriptLoader;

// Init



// Statics




// Export

exports.default = ScriptLoader;